import React, { useState, useCallback } from "react";
import { FormGroup, Label, Input } from "reactstrap";
import _ from "lodash";
import ProductImages from "./ProductImages";
import { formatMoney } from "accounting";
import CategoryBadge from "./CategoryBadge";
import AddProductToCartButton from "./AddProductToCartButton";

const pathsObjectToArray = paths =>
  _.map(Object.keys(paths), key => ({
    name: key,
    path: `${process.env.REACT_APP_API_URL}/${paths[key]}`
  }));

const ProductDetail = ({ product }) => {
  const [selectedVariant, setSelectedVariant] = useState(null);
  const variants = _.get(product, "variants", []);
  const onSelectVariant = useCallback(
    ev => {
      const nextVariant = _.find(
        variants,
        v => v.id === parseInt(ev.target.value, 10)
      );
      setSelectedVariant(nextVariant);
    },
    [variants]
  );
  if (product) {
    const productImages = product.images;
    const variantImages = pathsObjectToArray(
      _.get(selectedVariant, "images", {})
    );
    const categories = _.map(product.category_products, category => ({
      id: category.category_id,
      name: category.name_category
    }));
    return (
      <div className="product">
        <div className="product-detail">
          <div className="row">
            <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12 order-sm-1 order-2">
              <ProductImages
                images={selectedVariant ? variantImages : productImages}
              />
            </div>
            <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12 order-sm-2 order-1 mb-3">
              <div className="product-info mb-4">
                <p className="product-name">{product.name}</p>
                <p className="product-description">{product.description}</p>
                <p className="product-price">
                  {formatMoney(
                    selectedVariant ? selectedVariant.price : product.price
                  )}
                </p>
              </div>
              <div>
                <h5>Product Categories</h5>
                <div className="row mb-3">
                  {_.map(categories, category => (
                    <div key={category.id} className="col-auto">
                      <CategoryBadge category={category} />
                    </div>
                  ))}
                </div>
              </div>
              {!_.isEmpty(variants) && (
                <div>
                  <FormGroup>
                    <Label for="exampleSelect">Select product variant</Label>
                    <Input
                      type="select"
                      name="select"
                      id="exampleSelect"
                      value={_.get(selectedVariant, "id", "")}
                      onChange={onSelectVariant}
                    >
                      <option value="">Default</option>
                      {_.map(variants, v => (
                        <option key={v.id} value={v.id}>
                          {v.name}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                </div>
              )}
              <AddProductToCartButton
                productId={product.id}
                variantId={_.get(selectedVariant, "id", null)}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
  return null;
};

export default ProductDetail;
